<template>
    <div style="background-color:#fff">
        <!-- MODAL IS HERE -->
        <modal  :scrollable="true" name="submissionFailure" @before-open="beforeOpen" height="auto" :minHeight="150" width="400">
            <div class=""  role="document">
                <div class="">
                    <!-- Modal content-->
                    <submissionFailure/>			  			 					
                </div>
            </div>
        </modal>
       
            
            <!-- Header -->
            <header>
                <div class="container container-custom">
                    <nav class="navbar navbar-expand-md navbar-light">
                        <a class="navbar-brand" href="index.html"><img src="/images/logo.png" alt="Logo" /></a>
                        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#NavbarToggle" aria-controls="NavbarToggle" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse" id="NavbarToggle">
                            <!-- <ul class="navbar-nav">
                                <li><a class="nav-link" href="#">Administrators</a></li>
                                <li><a class="nav-link" href="#">Owner</a></li>
                            </ul> -->

                            <ul class="navbar-right">
                                <li> 
                                  <router-link class="btn_head1" v-if="!user" :to="{ name: 'login'}">Sign In</router-link> 
                                  <router-link class="btn_head1" v-else-if="isOwner" :to="{ name: 'propertiesowner'}">Platform</router-link>
                                  <router-link class="btn_head1" v-else  :to="{ name: 'buildings'}">Platform</router-link>
                                </li>
                                <li> <a  href="/registerbuilding" class="btn_head2"> Get Started </a></li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </header>
            <!-- End Header -->


            <!-- Hero -->
            <section class="hero-wrp">
                <div class="container container-custom">
                    <img src="/images/logo.png" alt="">
                    <h2>Instant way to <br> manage.</h2>
                    <p>A comprehensive financial services and maintenance <br> management platform.</p>
                </div>
            </section>
            <!-- End Hero -->

            <!-- platform -->
            <section class="platform-wrp">
                <div class="container container-custom">
                    <h2>A comprehensive financial services & <br> maintenance management platform</h2>
                    <p>A Platform which adapts to various market needs such as the maintenance & management of buildings, <br> houses, yachts in marines, gardens, swimming pools, etc.</p>
                    <p>The OpenPlan is a platform used by administrators or companies that manage buildings and marines <br> that provide services & maintain products.</p>
                    <p>With the digitization and centralization of data as well as with automated tools our goal is ot reduce the <br> time in the field of management & maintenance, resulting in an increase in your profitability</p>
                </div>
            </section>
            <!-- End platform -->
<!-- BENEFITS -->
<section class="benefits-wrp">
                <div class="container container-custom">
                    <div class="titlebar">
                        <h2>KEY BENEFITS</h2>
                        <p>This platform offers the following benefits to <br> the owners: Centralized utilities management</p>
                    </div>

                    <div class="key-benefitlst">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                                    <div class="benefits-block">
                                        <h3>SERVICES PROVIDER</h3>
                                        <h6>Real time data</h6>

                                        <div class="benifit-imgbx">
                                            <img src="/images/benifit-ic1.png" alt="">
                                        </div>
                                    </div>
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">
                                    <div class="benefits-block">
                                        <h3>ADMINISTRATOR</h3>
                                        <h6>Multiple property management access</h6>

                                        <div class="benifit-imgbx">
                                            <img src="/images/benifit-ic2.png" alt="">
                                        </div>
                                    </div>
                                </button>
                            </li>
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">
                                    <div class="benefits-block">
                                        <h3>OWNER</h3>
                                        <h6>Centralised Utilities Management</h6>

                                        <div class="benifit-imgbx">
                                            <img src="/images/benifit-ic3.png" alt="">
                                        </div>
                                    </div>
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div class="benefit-slider">
                        <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                                <div class="slider-box">
                                    <div class="slider-img">
                                        <img src="/images/benifit-ic1.png" alt="">
                                    </div>

                                   <div class="bendt">
                                        <h2>SERVICES PROVIDER</h2>
                                        <p>A Platform which adapts to various market needs such as the maintenance & management of buildings, <br> houses, yachts in marines, gardens, swimming pools, etc.</p>
                                        <div class="collapse" id="collapseExample">
                                            <p>With the digitization and centralization of data as well as with automated tools our goal is ot reduce the <br> time in the field of management & maintenance, resulting in an increase in your profitability</p>
                                        </div>

                                        <a class="read-more" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">Read More</a>
                                   </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                                <div class="slider-box">
                                    <div class="slider-img">
                                        <img src="/images/benifit-ic2.png" alt="">
                                    </div>

                                   <div class="bendt">
                                        <h2>ADMINISTRATOR</h2>
                                        <p>Multiple property management access</p> <br> 
										<p>Ability to issue automated payment receipts for owners</p>
										<p>Synchronization of 2 or more software programs so that expense / income entries appear in both or more systems</p>
                                        <div class="collapse" id="collapseExample2">
                                            <!-- <p>With the digitization and centralization of data as well as with automated tools our goal is ot reduce the <br> time in the field of management & maintenance, resulting in an increase in your profitability</p>-->
                                        </div>

                                        <a class="read-more" data-bs-toggle="collapse" href="#collapseExample2" role="button" aria-expanded="false" aria-controls="collapseExample2"><!--Read More--></a>
                                   </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                                <div class="slider-box">
                                    <div class="slider-img">
                                        <img src="/images/benifit-ic3.png" alt="">
                                    </div>

                                   <div class="bendt">
                                        <h2>SERVICES PROVIDER</h2>
                                        <p>A Platform which adapts to various market needs such as the maintenance & management of buildings, <br> houses, yachts in marines, gardens, swimming pools, etc.</p>
                                        <div class="collapse" id="collapseExample3">
                                            <p>With the digitization and centralization of data as well as with automated tools our goal is ot reduce the <br> time in the field of management & maintenance, resulting in an increase in your profitability</p>
                                        </div>

                                        <a class="read-more" data-bs-toggle="collapse" href="#collapseExample3" role="button" aria-expanded="false" aria-controls="collapseExample3">Read More</a>
                                   </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="titlebar preview-title">
                        <h2>PREVIEW</h2>
                        <p>Real Estate Page: manafe your houses <br> and filter by catefories</p>
                    </div>
                    <div class="preview-slider" style="margin-top:50px;">
                        <div class="slider single-items">
                            <div>
                                <div class="slider-box">
                                    <img src="/images/screenshot.png" alt="">
                                </div>
                            </div>
                             <div>
                                <div class="slider-box">
                                    <img src="/images/screenshot2.png" alt="">
                                </div>
                            </div>
                             <div>
                                <div class="slider-box">
                                    <img src="/images/screenshot3.png" alt="">
                                </div>
                            </div>
                            <div>
                                <div class="slider-box">
                                    <img src="/images/screenshot4.png" alt="">
                                </div>
                            </div>
                            <div>
                                <div class="slider-box">
                                    <img src="/images/screenshot5.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- End BENEFITS -->


            
        
    </div>
</template>

<script>
import { authenticationService } from "@/_services";
import { Role } from "@/_helpers";

export default {
  data() {
    return {
      items: [
        { title: "Web developer", link: "/careers/webdeveloper" },
        {
          title: "Customer service & support officer",
          link: "/careers/customerservice",
        },
      ],
      list: [{
          url: '/images/screenshot.png'
        },
        {
          url: '/images/screenshot2.png'
        },
        {
          url: '/images/screenshot3.png'
        },
        {
          url: '/images/screenshot4.png'
        },
        {
          url: '/images/screenshot5.png'
        }
      ],
      active: 0,
      activeKey:1,
      disabled: false,
      absolute: false,
      openOnHover: false,
      value: false,
      closeOnClick: true,
      closeOnContentClick: true,
      offsetX: false,
      offsetY: true,
      currentUser: null,
      fromEmail: "",
      name: "",
      message: "",
      errorMessage: "",
      errorMessageStyle: {
        color: "#015A6C",
        "font-size": "1.3em",
        "font-style": "italic",
        "font-weight": "bold",
        "text-align": "center",
      },
      submitted: false,
      invalidInputMessageStyle: {
        "font-size": "13",
        color: "#015A6C",
        "text-align": "right",
        "font-weight": "bold",
      },
    };
  },
  methods: {
    moveSlide(event) {
      this.active = event.srcElement.dataset.slide
      this.list.forEach(el => {
        el.active = false
      })
      this.list[event.srcElement.dataset.slide].active = true
    },
    rotate() {
      if (this.active < this.numberOfSlides) {
        this.active = this.active + 1
      } else {
        this.active = 0
      }
      let _this = this
      setTimeout(_this.rotate, 3000)
    },
    submitForm: function () {
      let canSubmit = this.name && this.fromEmail && this.message;
      this.submitted = true;
      if (canSubmit) {
        this.$http
          .post("/email/contactus", {
            fromEmail: this.fromEmail,
            name: this.name,
            message: this.message,
          })
          .then(
            () => {
              this.submitted = false;
              this.errorMessage = "Form was submitted successfully!";
              this.clearForm();
              // this.submissionFailure()
            },
            () => {
              // this.errorMessage = 'Form submission failed. Check your internet connection.';
              // alert('Form submission failed. Check your internet connection.')
              // this.clearForm()
              this.submissionFailure();
              this.submitted = false;
            }
          );
      }
    },
    clearForm: function () {
      (this.name = ""), (this.fromEmail = ""), (this.message = "");
    },
    submissionFailure: function () {
      this.$modal.show("submissionFailure");
    },
    next(){
      this.active++
      if(this.active >= this.maxActive)
        this.active = 0
    },
    previous(){
      this.active--;

      if(this.active < 0)
        this.active = this.maxActive - 1
    },
    nextKey(){
      this.activeKey++
      if(this.activeKey > 2)
        this.activeKey = 0
    },
    previousKey(){
      this.activeKey--;

      if(this.activeKey < 0)
        this.activeKey = 2
    },
    setActiveKey(temp){
      this.activeKey = temp
    }
  },

  computed: {
   maxActive(){
return this.list.length
   },
    numberOfSlides() {
      return this.list.length - 1
    },
    imageUrl() {
      return this.list[this.active].url;
    },
    user() {
      return authenticationService.currentUserValue;
      /* alert( this.$store.state.authentication.user)
            return this.$store.state.authentication.user;*/
    },
    isAdmin() {
      return this.currentUser && this.currentUser.role === Role.Admin;
    },
    isOwner() {
      return this.currentUser && this.currentUser.role === Role.Owner;
    },
    users() {
      return this.$store.state.users.all;
    },
    formIsValid() {
      return this.name && this.fromEmail && this.message;
    },
    emailClasses() {
      return {
        touched: this.fromEmail.length !== 0,
        invalid: this.fromEmail && !this.emailIsValid,
      };
    },
    inputEmail() {
      return this.fromEmail.length > 0;
    },
    emailIsValid() {
      return this.fromEmail.includes("@");
    },
    emailNotValid: function () {
      if (this.fromEmail.includes("@")) {
        return false;
      } else {
        return true;
      }
    },
  },

  created() {
    authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
    //this.rotate()
    //  this.$store.dispatch('users/getAll');
  },
};
</script>